import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.item.url}}
  <AvatarFlair
    @flairName={{this.item.name}}
    @flairUrl={{this.item.url}}
    @flairBgColor={{this.item.bgColor}}
    @flairColor={{this.item.color}}
  />
{{/if}}

<span>{{this.label}}</span>
*/
{
  "id": "1PGWViyC",
  "block": "[[[41,[30,0,[\"item\",\"url\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@flairName\",\"@flairUrl\",\"@flairBgColor\",\"@flairColor\"],[[30,0,[\"item\",\"name\"]],[30,0,[\"item\",\"url\"]],[30,0,[\"item\",\"bgColor\"]],[30,0,[\"item\",\"color\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,1],[12],[1,[30,0,[\"label\"]]],[13]],[],false,[\"if\",\"avatar-flair\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/selected-flair.hbs",
  "isStrictMode": false
});